import axios from 'axios'
import Vue from 'vue'
import i18n from '../../../../i18n';

const state = {
    token: localStorage.getItem('user-token') || '',
    loading: true,
    productDesigns: [],
    productDesign: {},
    message: {},
}

const getters = {
    getAllProductDesigns(state){
        return state.productDesigns;
    },
    getProductDesign(state){
        return state.productDesign;
    },
    getBannerResponseMsg(state){
        return state.message;
    },
}

const mutations = {
    updateAllProductDesigns(state, productDesigns) {
        state.productDesigns = productDesigns
     },
     updateProductDesign(state, productDesign) {
        state.productDesign = productDesign
     },
     updatePDesponseMsg(state, message) {
        state.message = message
     },
}

const actions = {
    ['LOAD_ALL_PRODUCT_DESIGNS']: ({commit}) => {
        return new Promise((resolve) => {
        axios.get('product-design?limit=100',
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateAllProductDesigns', resp.data.data)
            } else {
              console.log('Error')
            }
            resolve(resp)
            })
        })
    },

    ['CREATE_PRODUCT_DESIGN']: ({commit}, data) => {
        return new Promise((resolve) => {
        axios.post(`product-design`, data ).then(resp => {
            if(!resp.data.error){
                commit('updatePDesponseMsg', resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

    ['UPDATE_PRODUCT_DESIGN']: ({commit}, data) => {
        console.log('data', data)
        return new Promise((resolve) => {
            axios.put(`product-design/` + data.id, data.form)
                .then(resp => {
                    if(!resp.data.error){
                        commit('updatePDesponseMsg', resp.data)
                        Vue.toasted.show(i18n.tc(`successfully`),{
                            theme: 'outline',
                            singleton: true,
                            position:'top-center',
                            action :
                                {
                                    text : i18n.tc(`ok`),
                                    onClick : (e, toastObject) => {
                                        toastObject.goAway(0);
                                    }
                                }
                        });
                    } else {
                        console.log(resp.data.error)
                    }
                    resolve(resp)
                })
        })
    },

      ['GET_PRODUCT_DESIGN']: ({commit}, id) => {
        return new Promise((resolve) => {
        axios.get(`product-design/${id}`,
        {}).then(resp => {
            if(!resp.data.error){
                commit('updateProductDesign', resp.data.data)
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

      ['DELETE_PRODUCT_DESIGN']: ({commit}, id) => {
        return new Promise((resolve) => {
        axios.delete(`product-design/${id}`,
        {}).then(resp => {
            if(!resp.data.error){
                commit('updatePDesponseMsg', resp.data.data)
                console.log(resp.data)
                Vue.toasted.show(i18n.tc(`successfully`),{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                });
            } else {
              console.log(resp.data.error)
            }
            resolve(resp)
            })
        })
      },

}

export default {
    state,
    getters,
    mutations,
    actions
}
